import React from "react"

export function SettingsItem({
  icon,
  label,
  actionIcon,
  disabled,
  onClick,
}: {
  icon: React.ReactNode
  label: string
  actionIcon?: React.ReactNode
  disabled?: boolean
  onClick?: () => void
}) {
  return (
    <button
      className="flex w-full items-center justify-between rounded-medium p-3 hover:bg-component-gray-1 disabled:cursor-default disabled:opacity-50 disabled:transition-colors disabled:duration-300"
      disabled={disabled}
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className="mr-4 flex size-15 items-center justify-center rounded-medium bg-component-gray-1">
          {icon}
        </div>
        <div className="font-semibold">{label}</div>
      </div>
      <div className="flex h-full items-center">{actionIcon}</div>
    </button>
  )
}
